import { makeStyles } from "@material-ui/core";
import _ from "lodash";
import { Button } from "react-admin";
import { useFormState } from "react-final-form";

interface ISaveChangeLocationButton {
  handleClose: () => void;
  routeLocationData: any;
  changeLocationCallback: any;
}

const useStyles = makeStyles({
  saveButton: {
    width: "100%",
    marginTop: 10,
    marginLeft: 0,
    borderRadius: 0,
    padding: 15,
    backgroundColor: "#E7E7E7",
    color: "#4E4E4E",
    fontWeight: 600,
    boxShadow: "unset",
    "&:hover": {
      backgroundColor: "#D8D8D8 !important",
    },
  },
});

const SaveChangeLocationButton = ({
  handleClose,
  routeLocationData,
  changeLocationCallback,
}: ISaveChangeLocationButton) => {
  const classes = useStyles();
  const { values } = useFormState();
  const newRouteLocation = _.clone(routeLocationData);
  const oldRouteLocation = routeLocationData;

  const handleSaveChangeLocation = () => {
    if (values.locationData) {
      newRouteLocation.blockNumber = values.locationData.BLK_NO;
      newRouteLocation.building = values.locationData.BUILDING;

      if (values.locationData.POSTAL === "NIL") {
        const splitedBuilding = values.locationData.BUILDING.split(" ");

        newRouteLocation.postalCode = splitedBuilding[0];
      } else {
        newRouteLocation.postalCode = values.locationData.POSTAL;
      }

      newRouteLocation.street = values.locationData.ROAD_NAME;
      newRouteLocation.lat = values.locationData.LATITUDE;
      newRouteLocation.lng = values.locationData.LONGITUDE;
      newRouteLocation.address = values.locationData.ADDRESS;

      changeLocationCallback(newRouteLocation, oldRouteLocation);
    }

    console.log("TEST locationData", values.locationData);
    console.log("TEST newRouteLocation", newRouteLocation);
  };

  return (
    <Button
      label="Save"
      className={classes.saveButton}
      onClick={() => {
        handleSaveChangeLocation();
        handleClose();
      }}
    />
  );
};

export default SaveChangeLocationButton;
